import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useState } from "react";

import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  clientSecret: string;
  stripePublicKey: string;
};

export default function LoadStripe(props: Props) {
  const [promise] = useState(loadStripe(props.stripePublicKey));
  return (
    <Elements
      options={{
        clientSecret: props.clientSecret,
      }}
      stripe={promise}
    >
      {props.children}
    </Elements>
  );
}
